import React from 'react';
import AmamentacaoPraticaLP from '../components/AmamentacaoPraticaLP';
import PreloadResources from '../components/PreloadResources';

// Oferta R$147 — mesma página da home, só muda o box de preço e o checkout.
const CHECKOUT_147 = "https://pay.hotmart.com/B99235195O?off=prxcszkk&checkoutMode=10&src=offer147";

const Offer147Page = () => {
  return (
    <>
      <PreloadResources lcpImagePath="/lovable-uploads/cf978e16-cc7f-4926-84e7-12e94ef564c1.png" />
      <AmamentacaoPraticaLP
        checkoutUrl={CHECKOUT_147}
        priceMain="R$ 147,00"
        priceInstallments="ou em até 12x de R$ 15,30"
      />
    </>
  );
};

export default Offer147Page;
